export function itemMapper(item) {
    if (!item) {
        return {};
    }
    const productoDesc = item.producto_id.trim() === 'WCAMNOST' ? 'CAMARA NO ESTANDAR' : item.producto?.B1_DESC;
    const webGroupID = item.producto_id.trim() === 'WCAMNOST' ? 'WCAM' : item.producto?.B1_WGRUP;
    const camara_data = item.camara_data
        ? (typeof item.camara_data === 'string' ? JSON.parse(item.camara_data) : item.camara_data)
        : null;
    const design = item.design
        ? (typeof item.design === 'string' ? JSON.parse(item.design) : item.design)
        : null;
    return {
        form: { ...item, camara_data, design },
        producto: {
            productoID: item.producto_id,
            productoDesc,
            label: item.producto_id,
            precio: item.lista_precio_valor,
            listaPrecioID: item.lista_precio_id,
            webGroupID,
            plazo: parseInt(item.plazo),
        },
    };
}
